var recommendForm = document.getElementById('recommend-modal-form');

if (recommendForm) {
    recommendForm.addEventListener('submit', processRecommendForm);

    var recommendFormEmailInvalid = document.getElementById('recommend-modal-email-error');
    var recommendFormEmailError = document.getElementById('recommend-modal-error');
    var recommendFormEmailSent = document.getElementById('recommend-modal-success');
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
        if(request.readyState === 4) {
            if(request.status === 200) {
                var response = JSON.parse(request.responseText);
                // TODO: check response.
                if (response.result) {
                    recommendFormEmailInvalid.style.removeProperty('display');
                    recommendFormEmailError.style.removeProperty('display');
                    recommendFormEmailSent.style.display = 'inline';
                }
            } else {
                recommendFormEmailInvalid.style.removeProperty('display');
                recommendFormEmailSent.style.removeProperty('display');
                recommendFormEmailError.innerText = request.status + ' ' + request.statusText;
                recommendFormEmailError.style.display = 'inline';
            }
        }
    };
}

function processRecommendForm(e) {
    e.preventDefault();

    recommendFormEmailInvalid.style.removeProperty('display');
    recommendFormEmailError.style.removeProperty('display');
    recommendFormEmailSent.style.removeProperty('display');

    var codeInput = recommendForm.querySelector('.product-recommend-modal__code-input');
    var emailInput = document.getElementById('recommend-modal-form-email');

    var isValid = validateEmail(emailInput.value);

    if (isValid && emailInput.value.length >= 6) {
        request.open('Post', recommendForm.action);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send(JSON.stringify({
            email: emailInput.value,
            product: codeInput.value
        }));
    } else {
        recommendFormEmailInvalid.style.display = 'inline';
    }
}

function validateEmail(email) {
    var regex = /\b[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,20}\b/gi;

    return regex.test(email);
}
